// export const API_URL = 'http://localhost:8010/proxy'; // local proxy
// export const API_URL = 'http://localhost:3000'; // local
export const API_URL = 'https://app.beverlyhillsmotoring.com';
export const WEBSITE_URL = 'https://beverlyhillsmotoring.com';

export const FLOOR_MAT_API_URLS = {
  BASE: 'https://ctiapi.com:443/api/v1',
  // BASE: 'http://localhost:8010/proxy', // local proxy
  INIT: '/init-configurator',
  YEAR: '/year/list',
  MAKE: '/make/list',
  MODEL: '/model/list',
  VEHICLE: '/vehicle-unique',
  PRODUCT_LIST: '/product/list',
  CART_INFO: '/get-cart-info'
}
